import { TMenuRow } from "../../gui/Menu/Menu";
import DateRangeFilter from "../widgets/DateRangeFilter";
import PortUtils from "../../portlibs/PortUtils";
import Toolbar from "../widgets/Toolbar";

export default function FixedToolbar(props:{onExport:Function}){
    const MenuOptions : TMenuRow<string>[] = [
        {id:"add",text:"New Fixed Income",url:{hash:PortUtils.createHash("", "add")}},
        {id:"export",text:"Export",onClick:() => props.onExport}
    ]
    return <Toolbar options={MenuOptions} showAll={true}><DateRangeFilter/></Toolbar>
}